import { render } from "./InformacoesAuditoria.vue?vue&type=template&id=008645d6"
import script from "./InformacoesAuditoria.vue?vue&type=script&lang=js"
export * from "./InformacoesAuditoria.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__